import { ComponentType } from "react";

import { MetricBlock } from "../api";

import AvoidableDamageTaken from "./AvoidableDamageTaken";
import BossDamage from "./BossDamage";
import CombatLog from "./CombatLog";
import Consumables from "./Consumables";
import DebuffUptime from "./DebuffUptime";
import EnchantsGems from "./EnchantsGems";
import EngineeringDamage from "./EngineeringDamage";
import Overview from "./Overview";
import PriorityTargetDamage from "./PriorityTargetDamage";
import TotalDamageDone from "./TotalDamageDone";
import TotalDamageTaken from "./TotalDamageTaken";

export type MetricView = ComponentType<{ block: MetricBlock }>;

// Virtual section (no backend metric block). Surfaced only when the report
// carries an `enrichment` pointer; its data is fetched by the CombatLog view.
export const COMBAT_LOG_METRIC = "combat_log";
export const COMBAT_LOG_BLOCK: MetricBlock = {
  title: "Enriched data",
  description:
    "Per-combat GCD timeline from the raw log — what each player pressed, in order, with the seconds between presses.",
  rows: [],
};

// Keys must match the backend `Metric.name` values. Anything not in this map
// renders via GenericTable, so a backend-only metric still shows up.
export const metricViews: Record<string, MetricView> = {
  overview: Overview,
  total_damage_done: TotalDamageDone,
  boss_damage: BossDamage,
  total_damage_taken: TotalDamageTaken,
  avoidable_damage_taken: AvoidableDamageTaken,
  consumables: Consumables,
  gear_audit: EnchantsGems,
  engineering_damage: EngineeringDamage,
  priority_target_damage: PriorityTargetDamage,
  debuff_uptime: DebuffUptime,
  [COMBAT_LOG_METRIC]: CombatLog,
};

// Metric names that should never render — even if they exist on a saved
// report (e.g. legacy reports stored before the metric was removed). The
// Sidebar and Report page filter their displayed list against this set.
//
// `enchants` and `gems` are still computed by the backend (their data
// feeds the unified Enchants & Gems view at `gear_audit`), but we hide
// the standalone sidebar entries to avoid duplicating the section.
export const HIDDEN_METRICS = new Set<string>([
  "sunder_casts",
  "enchants",
  "gems",
]);
